/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rf_Mode2Inputs */



/**
* | output |
* | --- |
* | "RF mode" |
*
* @param {Rf_Mode2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const rf_mode2 = /** @type {((inputs?: Rf_Mode2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rf_Mode2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("RF mode")
	return /** @type {LocalizedString} */ ("Mode RF")
});
export { rf_mode2 as "RF_mode" }